module.exports = __webpack_public_path__ + "media/images/lb/477-f00cbb3db4a619a03438e6360d17af0f.svg";